import { faFlowerTulip } from "@jewlr/pro-light-svg-icons/faFlowerTulip"
import { faGem } from "@jewlr/pro-light-svg-icons/faGem"
// import { faGift } from "@jewlr/pro-light-svg-icons/faGift"
// import { faPlane } from "@jewlr/pro-regular-svg-icons/faPlane"
// import { faBoxHeart } from "@jewlr/pro-regular-svg-icons/faBoxHeart"
import {
  FontAwesomeIcon,
  MediaFlex,
  Shimmer,
  Typography,
} from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
import styled from "styled-components"

// import { jewlr_t } from "helpers/application"
import { showHolidayShipMethodPDP } from "helpers/holiday"

const Container = styled(MediaFlex).attrs((props) => ({
  greaterThanOrEqual: "tablet",
  ...props,
}))`
  align-items: center;
  background: ${(props) =>
    props.holidayDelivery ? "#FCF2F2" : "rgba(0, 136, 0, 0.05)"};
  border-radius: 5px;
  height: 32px;
  justify-content: center;
  margin-bottom: 24px;
`

const PromoText = styled(Typography)`
  color: ${(props) => props.color};
  font-size: 14px;
  font-weight: 400;
  strong {
    font-weight: 600;
  }
`

const PromoDesktop = ({
  doubleJewlsPromo,
  doubleJewlsPromoMessage,
  holidayDelivery,
  outOfStock,
  prefStore,
  ship,
  wizardLoading,
}) => {
  if (outOfStock) return null
  if (
    !doubleJewlsPromo &&
    !sl.config.show_holiday_shipping_info_pdp &&
    (!showHolidayShipMethodPDP || holidayDelivery == false)
  ) {
    return null
  }
  if (
    wizardLoading ||
    !prefStore ||
    (showHolidayShipMethodPDP && holidayDelivery == undefined)
  ) {
    return (
      <Shimmer display={{ _: "none", tablet: "block" }} height="32px" mb={2} />
    )
  }

  let message = doubleJewlsPromoMessage
  if (holidayDelivery) {
    let dateMsg =
      ship.delivery_dates?.length > 0 ? ship.delivery_dates[0].date : ""
    message = (
      <>
        <strong>
          Arrives by{" "}
          {sl.config.guaranteed_holiday_alias || sl.config.guaranteed_holiday}
        </strong>
        {/* <strong>
          {sl.config.guaranteed_holiday} {jewlr_t("terms.Shipping")} Info
        </strong> */}
        {dateMsg && (
          <>
            {" "}
            - <strong>{dateMsg}</strong>
          </>
        )}
      </>
    )
  }

  if (!message) return null

  return (
    <Container holidayDelivery={holidayDelivery}>
      <FontAwesomeIcon
        color={holidayDelivery ? "sale" : "greenDarker"}
        fontSize="14px"
        icon={holidayDelivery ? faFlowerTulip : faGem}
        mr="6px"
      />
      <PromoText color={holidayDelivery ? "sale" : "greenDarker"}>
        {message}
      </PromoText>
    </Container>
  )
}

PromoDesktop.propTypes = {
  doubleJewlsPromo: PropTypes.bool,
  doubleJewlsPromoMessage: PropTypes.string,
  holidayDelivery: PropTypes.bool,
  outOfStock: PropTypes.bool,
  prefStore: PropTypes.bool,
  ship: PropTypes.object,
  wizardLoading: PropTypes.string,
}

const mapStateToProps = (state) => {
  return {
    doubleJewlsPromo: state.wizard.promo_double_jewls,
    doubleJewlsPromoMessage: state.wizard.promo_double_jewls_messaging,
    holidayDelivery: state.wizard.shipping.main?.available_holiday_delivery,
    outOfStock: state.wizard.header?.product_out_of_stock,
    prefStore: state.wizardUI.prefStore,
    ship: state.wizard.shipping.main,
    wizardLoading: state.wizard.loading,
  }
}

export default connect(mapStateToProps)(PromoDesktop)
